import {
  axiosInstance,
  client,
  type RequestConfig,
  type ResponseConfig,
  type ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import { isAxiosError } from "axios";
import Qs from "qs";
import { currentUser, getAccessJWT } from "./actions/helpers/auth";
import { getApiUrl } from "./Config";
import { toBroadcastSafeResponse } from "./lib/broadcastSafeResponse";

axiosInstance.interceptors.request.use(async (config) => {
  const local = import.meta.env?.VITE__LOCAL_LOGIN === "true";
  // @ts-expect-error
  config.baseURL = config.overrideBaseUrl || getApiUrl();
  if (local) {
    // `currentUser()` resolves the local test user (a string) in local mode.
    config.headers["X-Test-User"] = (await currentUser()) as string;
  } else {
    config.headers.Authorization = `Bearer ${await getAccessJWT()}`;
  }
  config.paramsSerializer = (params) => {
    return Qs.stringify(params, { arrayFormat: "repeat" });
  };
  return config;
});

axiosInstance.interceptors.response.use(
  // Strip the non-cloneable `config`/`request` so cached query data can cross a
  // BroadcastChannel for live cross-tab sync (see toBroadcastSafeResponse).
  (response) => toBroadcastSafeResponse(response),
  (error) => {
    if (isAxiosError(error) && error.response?.status === 401) {
      window.location.href = "/auth/login";
    }
    return Promise.reject(error);
  },
);

export type { RequestConfig, ResponseConfig, ResponseErrorConfig };

export { axiosInstance };

export default client;
